export default class Themes {
  static getDefaultTheme() {
    return 'canvas';
  }
}